import { makeStyles } from '@mui/styles'
import common from 'shared/styles'

const useStyles = makeStyles(() => {
    return {
        main: {
            ...common.fullContainer,
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: 30,
        },
        actions: {
            alignSelf: 'flex-start',
            flexGrow: 2,
        },
    }
})

export default useStyles
